import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f54e34ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = {
  key: 0,
  class: "search-result"
}
const _hoisted_4 = { class: "label" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Client", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Client email", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Client Alias", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Client type", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Assigned on", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("cancel")

import "@/assets/css/action-buttons.css";

import {
  ref,
  withDefaults,
  computed,
  Ref,
} from "vue";
import { Input as KInput } from "@progress/kendo-vue-inputs";
import BaseCommandModal from "../ActionModals/_BaseCommandModal.vue";
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { Loader as KLoader } from "@progress/kendo-vue-indicators";
import { AutoComplete as KAutoComplete } from "@progress/kendo-vue-dropdowns";
import { DropDownList as KDropDownList } from "@progress/kendo-vue-dropdowns";
import { DatePicker as KDatePicker } from "@progress/kendo-vue-dateinputs";

import {
  ClientManager,
  Client,
  CLIENT_TYPES,
  ClientType,
  CommissionUserRole,
} from "../typesAndConstants";
import ActionResultMessage from "./Components/ActionResultMessage.vue";

import * as api from "../api";
import { strIsoOfDate, makeAuditedCommandParams } from "../helpers";

//#endregion
type ModalProps = {
  show?: boolean;
  clientManager: ClientManager;
};

//#region PROPS

const __default__ = {
  name: "ChangeClientTypeModal",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    clientManager: null
  },
  emits: ["command-executed", "close-modal"],
  setup(__props: any, { emit }) {

const props = __props as { show: boolean, clientManager: ClientManager }

//#region IMPORTS

// Global CSS

//#endregion

//#region EMITS

//#endregion

const makeAuditValue = () => {
  return {
    ClientId: selectedClient.value?.Id ?? 0,
    ClientType: clientType.value.key,
    ClientAlias: clientAlias.value,
    AssignedOn: strIsoOfDate(selectedDate.value),
  };
};

const makeCommandParams = () => {
  const oldValue = null;
  const newValue = makeAuditValue();

  return makeAuditedCommandParams(
    CommissionUserRole.ClientManager,
    clientManagerId.value,
    oldValue,
    newValue,
    note.value,
  );
};

const saving = ref(false);
const showActionResultMessage = ref(false);
const note = ref("");

const errorMessages: Ref<string[]> = ref([]);
const hasError = computed(() => !!errorMessages.value.length);
const clientManagerId = computed(() => props.clientManager.Id ?? 0);
const clients: Ref<Client[]> = ref([]);
const selectedClient: Ref<Client | null> = ref(null);
const selectedDate = ref(new Date());
const opened = ref(false);
const searchInProgress = ref(false);
const clientAlias = ref("");
const clientType: Ref<{ key: ClientType; value: string }> = ref(
  CLIENT_TYPES[0],
);
const emails = computed(() =>
  clients.value.map(c => `${c.Email} (${c.FullName})`),
);

const clientManagerTitle = computed(() =>
  props.clientManager.Group?.includes("Account Handler")
    ? "Acount Handler"
    : "Sales Rep",
);

const clientManagerType = computed(() =>
  props.clientManager.Group?.includes("Account Handler") ? "AH" : "SR",
);

//#region EVENT HANDLERS
const onCloseModal = (): void => emit("close-modal");
const onCancel = () => emit("close-modal");
const onSave = async () => {
  try {
    errorMessages.value = [];
    showActionResultMessage.value = false;
    saving.value = true;
    await api.addClientToClientManager(makeCommandParams());
    emit("command-executed");
  } catch (error: any) {
    errorMessages.value.push(error?.message ? error?.message : error);
  } finally {
    saving.value = false;
    showActionResultMessage.value = true;
  }
};
const onClientSelected = (e: any) => {
  const value = e.target.value;
  const [email, _fullName] = value.split(" ");

  const result = clients.value.filter(c => c.Email == email);
  selectedClient.value = result[0];
};
const onUserInput = async (e: any) => {
  const value = e.target.value;
  if (value.length > 4) {
    try {
      searchInProgress.value = true;
      clients.value = await api.getInHouseClients(
        clientManagerType.value,
        value,
      );
      opened.value = true;
    } catch (error: any) {
      console.error(error);
    } finally {
      searchInProgress.value = false;
    }
  } else {
    clients.value = [];
  }
};

const onSearch = async (e: any) => {
  try {
    errorMessages.value = [];
    opened.value = false;
    switch (e.event?.type) {
      case "input":
        await onUserInput(e);
        break;
      case "click":
        onClientSelected(e);
        break;
      default:
        break;
    }
  } catch (error: unknown) {
    console.error(error);
    opened.value = false;
  }
};

const onDateChange = (event: any): void => {
  selectedDate.value = event.target.value;
};

const onNoteChange = (event: any): void => {
  note.value = event;
};

//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCommandModal, {
    show: props.show,
    title: 'Add New Client',
    onCloseModal: onCloseModal,
    onNoteChanged: onNoteChange
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(props.clientManager.FullName.slice(4)), 1)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(KAutoComplete), {
            "data-items": _unref(emails),
            placeholder: 'e.g. software@theprintspace.co.uk',
            opened: opened.value,
            loading: searchInProgress.value,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (onSearch($event)))
          }, null, 8, ["data-items", "placeholder", "opened", "loading"])
        ]),
        (selectedClient.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(clientManagerTitle)), 1),
              _createElementVNode("div", null, _toDisplayString(__props.clientManager.FullName.slice(4)), 1),
              _hoisted_5,
              _createElementVNode("div", null, _toDisplayString(selectedClient.value.FullName), 1),
              _hoisted_6,
              _createElementVNode("div", null, _toDisplayString(selectedClient.value.Email), 1),
              _hoisted_7,
              _createElementVNode("div", null, [
                _createVNode(_unref(KInput), {
                  modelValue: clientAlias.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clientAlias).value = $event)),
                  placeholder: "(optional)"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_8,
              _createElementVNode("div", null, [
                _createVNode(_unref(KDropDownList), {
                  modelValue: clientType.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((clientType).value = $event)),
                  "data-items": _unref(CLIENT_TYPES),
                  "text-field": 'value',
                  "data-item-key": 'key'
                }, null, 8, ["modelValue", "data-items"])
              ]),
              _hoisted_9,
              _createElementVNode("div", null, [
                _createVNode(_unref(KDatePicker), {
                  "default-value": selectedDate.value,
                  format: 'dd/MM/yyyy',
                  onChange: onDateChange
                }, null, 8, ["default-value"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (showActionResultMessage.value)
        ? (_openBlock(), _createBlock(ActionResultMessage, {
            key: 0,
            "has-error": _unref(hasError),
            "error-messages": errorMessages.value
          }, null, 8, ["has-error", "error-messages"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(KButton), {
        class: "action safe",
        disabled: !selectedClient.value,
        onClick: onSave
      }, {
        default: _withCtx(() => [
          (saving.value)
            ? (_openBlock(), _createBlock(_unref(KLoader), {
                key: 0,
                "theme-color": 'light',
                type: 'pulsing'
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, "Add client"))
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_unref(KButton), {
        class: "action no-action",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})